import {
  storyblokInit,
  getStoryblokApi,
  apiPlugin,
  StoryblokClient,
} from '@storyblok/react'

class StoryblokService {
  private token: string | undefined
  private client: StoryblokClient
  devMode = false
  query: { [index: string]: any } = {}
  constructor(token: string) {
    this.token = token
    storyblokInit({
      accessToken: token || 'missing_token',
      use: [apiPlugin]
    })

    this.client = getStoryblokApi()
  }

  getCacheVersion() {
    return this.client?.cacheVersion()
  }

  get(slug: string, params: any) {
    params = params || {}
    const release = this.getQuery('_storyblok_release')
    const storyblokQuery = this.getQuery('_storyblok') // This is added by Storyblok when loading the site from their iFrame

    if (
      storyblokQuery ||
      this.devMode ||
      (typeof window !== 'undefined' && window.storyblok)
    ) {
      params.version = 'draft'

      if (release) {
        params.from_release = release
      }
    }

    if (
      typeof window !== 'undefined' &&
      typeof window.StoryblokCacheVersion !== 'undefined'
    ) {
      params.cv = window.StoryblokCacheVersion
    }

    return this.client.get(slug, params)
  }

  setQuery(query: any) {
    this.query = query
  }

  getQuery(param: string) {
    return this.query[param]
  }

  getLayout(locale: string, uuid: string) {
    return this.get(`cdn/stories/${uuid}`, {
      resolve_relations: 'global-reference.reference',
      find_by: 'uuid',
      language: locale,
    })
  }
}

export const storyblokInstance = new StoryblokService(
  process.env.STORYBLOK_ACCESS_TOKEN as string,
)
